export default __webpack_public_path__ + "static/cer-4-407cc1111701ef31d71af13043fe34e4.webp";